export default __webpack_public_path__ + "static/media/controller.024adf5b.svg";